import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'summary-dynamic-profile',
    templateUrl: './summary-dynamic-profile.component.html',
    styleUrls: ['./summary-dynamic-profile.component.scss'],
    standalone: false
})
export class SummaryDynamicProfileComponent implements OnInit {
  @Input() description: string;
  @Input() riskStatus: string = '';
  constructor() {}

  ngOnInit() {}
}
